import styled from "styled-components";

export const ClientLicenceSpan = styled.span`
  float: left;
  max-width: 300px;
  bold {
    font-weight: 900;
  }
`;
